var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    transform: "translate(-70 -137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_6",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 6",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(70 137)",
    fill: "#3a4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "solid_hourglass-half",
    "data-name": "solid hourglass-half",
    d: "M9.844,0H.656A.656.656,0,0,0,0,.656v.438a.656.656,0,0,0,.656.656A5.426,5.426,0,0,0,3.961,7a5.426,5.426,0,0,0-3.3,5.25A.656.656,0,0,0,0,12.906v.438A.656.656,0,0,0,.656,14H9.844a.656.656,0,0,0,.656-.656v-.438a.656.656,0,0,0-.656-.656A5.426,5.426,0,0,0,6.539,7a5.426,5.426,0,0,0,3.3-5.25.656.656,0,0,0,.656-.656V.656A.656.656,0,0,0,9.844,0ZM7.791,10.5H2.709A2.937,2.937,0,0,1,5.25,8.313,2.937,2.937,0,0,1,7.791,10.5Zm0-7H2.709a5.13,5.13,0,0,1-.3-1.75H8.094A5.131,5.131,0,0,1,7.791,3.5Z",
    transform: "translate(76.75 142)",
    fill: "#fc1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.ee336b0fd283526e73b2252c7b6aa6bd.svg";
export { ForwardRef as ReactComponent };